import React from 'react';
import {View} from 'react-native';

import CartButton from '../../CartButton';
import WishlistButton from '../../WishlistButton';
import {actionsContainerStyles as styles} from '../styles';
import {ProductTileActionsProps} from '../types';

function ProductTileActions({
  item,
  showCartButton = true,
  showWishlistButton = false,
  fullWidth = true,
  testContext,
  containerStyle,
  testID,
}: ProductTileActionsProps & {fullWidth?: boolean}) {
  return (
    <View style={[styles.container, fullWidth && styles.fullWidth, containerStyle]} testID={testID}>
      {showWishlistButton ? <WishlistButton item={item} testContext={testContext} /> : null}
      {showCartButton ? (
        <View style={styles.cartButtonWrapper}>
          <CartButton item={item} testContext={testContext} />
        </View>
      ) : null}
    </View>
  );
}

export default ProductTileActions;
